const sanitizeNumber = (value) => String(value || "").replace(/[^\d]/g, "");

const normalizePhoneNumber = (value) => {
  const digits = sanitizeNumber(value);
  if (!digits) return "";

  // If user enters an Indian 10-digit mobile number, prefix country code 91.
  if (digits.length === 10) return `91${digits}`;
  if (digits.length === 11 && digits.startsWith("0")) return `91${digits.slice(1)}`;

  return digits;
};

const DEFAULT_WHATSAPP_NUMBER = "8989052233";

export const WHATSAPP_NUMBER = normalizePhoneNumber(
  process.env.REACT_APP_WHATSAPP_NUMBER || DEFAULT_WHATSAPP_NUMBER
);

const getOrigin = () => {
  if (typeof window === "undefined") return "";
  return window.location?.origin || "";
};

export const buildWhatsAppLink = ({ number = WHATSAPP_NUMBER, text }) => {
  const phone = normalizePhoneNumber(number);
  const message = text == null ? "" : String(text);
  if (!phone) return "#";
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
};

export const buildProductEnquiryText = ({
  name,
  price,
  id,
  url,
  type = "product",
} = {}) => {
  const itemName = name || "Product";
  const itemTypeLabel = type === "banner" ? "Banner" : "Product";

  const lines = [
    `Hello, I want to enquire about this ${itemTypeLabel}:`,
    `Name: ${itemName}`,
    price ? `Price: ₹${Number(price).toLocaleString()}` : null,
    id != null && id !== "" ? `${itemTypeLabel} ID: ${id}` : null,
    url ? `Link: ${url}` : null,
  ].filter(Boolean);

  return lines.join("\n");
};

export const getProductEnquiryLink = (product, { type = "product" } = {}) => {
  const productId = product?.id ?? "";
  const detailsUrl =
    productId !== ""
      ? `${getOrigin()}/products2/${productId}?type=${type}`
      : getOrigin();

  const text = buildProductEnquiryText({
    type,
    id: productId,
    name: product?.name || product?.title,
    price: product?.selling_price,
    url: detailsUrl,
  });

  return buildWhatsAppLink({ text });
};

export const buildServiceEnquiryText = ({ title, url } = {}) => {
  const serviceTitle = title || "Service";
  const lines = [
    "Hello, I want to enquire about this service:",
    `Service: ${serviceTitle}`,
    url ? `Link: ${url}` : null,
  ].filter(Boolean);
  return lines.join("\n");
};

export const getServiceEnquiryLink = (service, { url } = {}) => {
  const text = buildServiceEnquiryText({
    title: service?.title || service?.name,
    url: url || (typeof window !== "undefined" ? window.location?.href : ""),
  });
  return buildWhatsAppLink({ text });
};
